import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { SellingPoint } from '../../../../components/custom';
import { Alert } from '../../../../components/general';

import { URL } from '../../../../constants';

import useSampleProjectData from '../../../../hooks/useSampleProjectData';

import { useProjectStore } from '../../../../stores/project';

import { Person, HlReel, Shot } from '../../../../types';
import { getUrl } from '../../../../utils';

import { getReviewText } from '../../components/getText';
import VBBtn from './vbBtn';

interface Props {
  hlReel: HlReel | null;
  requiredShots: Shot[];
  completePeople: Person[];
  incompletePeople: Person[];
  generatedPeople: Person[];
  isGenerationStage: boolean;
}

const ReviewSubStep: React.FC<Props> = (props) => {
  const { eventId = '' } = useParams();

  const {
    hlReel,
    requiredShots,
    completePeople,
    incompletePeople,
    generatedPeople,
    isGenerationStage,
  } = props;

  const { currentProject } = useProjectStore();

  // sample project data
  const { isSample } = useSampleProjectData(eventId);

  const { reviewAlert, reviewText } = getReviewText({
    currentProject,
    hlReel,
    requiredShots,
    completePeople,
    incompletePeople,
    generatedPeople,
    isSample,
  });

  if (isGenerationStage)
    return (
      <React.Fragment>
        <div>
          {reviewText}{' '}
          {!isSample && (
            <Link to={getUrl(URL.VB_REVIEW, eventId)}>Review again</Link>
          )}
        </div>
      </React.Fragment>
    );

  return (
    <React.Fragment>
      {reviewText && <SellingPoint text={reviewText} />}

      {reviewAlert && (
        <Alert alertData={{ variant: 'warning', text: reviewAlert }} />
      )}

      <VBBtn
        type="review"
        heading="Review"
        subheading="Review people's clips found by AI"
        link={getUrl(URL.VB_REVIEW, eventId)}
      />
    </React.Fragment>
  );
};

export default ReviewSubStep;
